import { createContext } from 'react';

export type ConfirmTone = 'danger' | 'success';

export type ConfirmOptions = {
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Confirm button color: 'danger' (red, default) for destructive actions, 'success' (green) for constructive ones. */
  tone?: ConfirmTone;
};

export type ConfirmFn = (message: string, options?: ConfirmOptions) => Promise<boolean>;

export const ConfirmDialogContext = createContext<ConfirmFn | null>(null);
